export default "__VITE_ASSET__y167SS$C__"